import React from 'react';
import { connect } from 'react-redux';
import {
    Card, CardBlock, CardTitle,
    Modal, ModalHeader, ModalBody, ModalFooter,
    Button, Label,FormGroup, Input,Row, Col 
} from 'reactstrap';



import {Link} from 'react-router-dom';

import ReactTable from "react-table";
import "react-table/react-table.css";

import IconPrint from 'react-icons/lib/fa/print';
import IconOpen from 'react-icons/lib/fa/folder-open-o';
import FAplus from 'react-icons/lib/fa/plus';
import FAprint from 'react-icons/lib/fa/print';
import IconEdit from 'react-icons/lib/md/edit';
import IconSave from 'react-icons/lib/md/save';

import * as actions from '../../actions/ticket';
import swal from 'sweetalert2'
import moment from 'moment';

import {API_URL} from '../../actions/_request';
import {api,API_UR} from '../../actions/_request';
import Select , {Async}  from 'react-select';
import _ from "lodash";
import Spinner from 'react-spinkit';
const tipos = [
    {label: 'Todos', value: 2},
    {label: 'Pagados', value: 1},
    {label: 'Pendientes', value: 0},
];

const SubmitLoad = () => (
    <div className="p-2">
        <Spinner name="ball-clip-rotate-multiple" color="#b5271f" />
    </div>
);

const requestData = (pageSize, page, sorted, filtered,mes,ano,departamento,tipo) => {    
    return new Promise((resolve, reject) => {
      console.log('mes--->',mes);
      console.log('ano--->',ano);
      console.log('departamento--->',departamento);
        // You can retrieve your data however you want, in this case, we will just use some local data.
        let filteredData ;
        var fecha_pago="";
        var clave="";
        var asesor="";
        var cliente="";
        var factura="";
        var subtotal="";

        var take= pageSize;
        var skip=pageSize * page;
        var total=1;  
        for (var i = filtered.length - 1; i >= 0; i--) {
          switch(filtered[i].id)
          {
            case "fecha_pago":
              fecha_pago=filtered[i].value;
              break;
            case "clave":
              clave=filtered[i].value;
              break;            
            case "cliente":
              cliente=filtered[i].value;
              break;
            case "asesor":
              asesor=filtered[i].value;
              break;   
            case "factura":
              factura=filtered[i].value;
              break;
            case "subtotal":
              subtotal=filtered[i].value;
              break;          
          }
        }
        // api().get(`/medidas/conteo?id=${value}&label=${label}&tipo=${tipo}&porcentaje=${porcentaje}&take=${take}&skip=${skip}`)
        api().get(`/tickets_departamentos/conteo_mes?mes=${mes}&ano=${ano}&departamento=${departamento}&tipo=${tipo}&fecha_pago=${fecha_pago}&clave=${clave}&cliente=${cliente}&asesor=${asesor}&factura=${factura}&subtotal=${subtotal}`)
        .then(function(response)
        {
            if(response.status === 200)
            {
              total= response.data[0].total; 
              api().get(`/tickets_departamentos/busqueda_mes?mes=${mes}&ano=${ano}&departamento=${departamento}&tipo=${tipo}&fecha_pago=${fecha_pago}&clave=${clave}&cliente=${cliente}&asesor=${asesor}&factura=${factura}&subtotal=${subtotal}&take=${take}&skip=${skip}`)
              .then(function(response)
              {
                if(response.status === 200)
                {
                  filteredData= response.data; 
                  // You can also use the sorting in your request, but again, you are responsible for applying it.
                  const sortedData = _.orderBy(
                    filteredData,
                    sorted.map(sort => {
                      return row => {
                        if (row[sort.id] === null || row[sort.id] === undefined) {
                          return -Infinity;
                        }
                        return typeof row[sort.id] === "string"
                        ? row[sort.id].toLowerCase()
                        : row[sort.id];
                      };
                    }),
                    sorted.map(d => (d.desc ? "desc" : "asc"))
                  );
                  const res = {
                    rows: sortedData,
                    pages: Math.ceil(total / pageSize)
                  };
                  // Here we'll simulate a server response with 500ms of delay.
                  //setTimeout(() => resolve(res), 1000);
                  //console.log(res);
                  resolve(res)
                }
              });   
            }
        });
    });
};


        



class TicketTable extends React.Component {

    constructor(props) {

        super(props);

   this.state = {     
      data:[],
      pages: null,
          loading: true,
          tipo:2,
          recargar:true,
          modal:false,
          ticket:{

          },
          fecha_pago:null,
          };
          this.fetchData = this.fetchData.bind(this);
           this.recargar2 = this.recargar2.bind(this);
          this.toggle = this.toggle.bind(this);
          this.handleSelectChange = this.handleSelectChange.bind(this);
           this.handleInputChange = this.handleInputChange.bind(this);
            this.handleSubmit = this.handleSubmit.bind(this);


    

    }

    handleSubmit(evt)
    {
        evt.preventDefault();
        let {ticket,fecha_pago} = this.state;
        let data={
          id:ticket.id,
          fecha_pago:fecha_pago,
        }
       
       
        let save=true;
        
        let self = this;        
        if(save){

        swal({
          title: 'Estas seguro?',
          text: "De Cambiar la  fecha de pago:"+fecha_pago,
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Estoy Seguro!',
          cancelButtonText: 'Cancelar!'
        }).then((result) => {
          if (result.value) {
                this.props.pagar_credito(data, (data) => {
                   self.props.alerta({
                      mensaje:"Ticket Modificado Correctamente",
                      tipo:"success",
                      creacion:moment().format('Y-MM-DD H:m:s'),
                    });
                 
                          self.toggle();
                          self.setState({
                                 recargar:false, 
                                    });
                   
              });
         }
        })
                
        }else{
            swal("Oops..", "Por favor Verificar el Campo de ");

        }
    }
    toggle(evt, ticket = {})
    {
        let {modal} = this.state;

        this.setState({
            modal       : !modal,
            ticket : ticket,
            fecha_pago:ticket.fecha_pago,
            
        });
    }
    recargar2(){
      this.setState({
        recargar:true,
    });
    }
    handleSelectChange(select, name) {

    const value = select === null ? null : select.value;

    this.setState({
        [name]: value,
        recargar:false,
        data:[],
        
    });

    
  }

  handleInputChange(event) {
       
        const target    = event.target;
        const value     = target.type === 'checkbox' ? target.checked : target.value;
        const name      = target.name;

      
     
        this.setState({
            [name] : value
        });
    }
   componentDidMount(){}
  componentWillReceiveProps(nextProps)
  {

  }
    fetchData(state, instance) {
        // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
        // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
        this.setState({ loading: true });
        // Request the data however you want.  Here, we'll use our mocked service we created earlier
        requestData(
          state.pageSize,
          state.page,
          state.sorted,
          state.filtered,
          this.props.mes,
          this.props.ano,
          this.props.departamento,
          this.state.tipo,
        ).then(res => {
          // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
          this.setState({
            data: res.rows,
            pages: res.pages,
            loading: false
          });
        });
    }

    formateo(value) {
     var decimals =  2;
   var  separators =[',', ",", '.'];
    var number = (parseFloat(value) || 0).toFixed(decimals);
    if (number.length <= (4 + decimals))
        return '$' +number.replace('.', separators[separators.length - 1]);
    var parts = number.split(/[-.]/);
    value = parts[parts.length > 1 ? parts.length - 2 : 0];
    var result = value.substr(value.length - 3, 3) + (parts.length > 1 ?
        separators[separators.length - 1] + parts[parts.length - 1] : '');
    var start = value.length - 6;
    var idx = 0;
    while (start > -3) {
        result = (start > 0 ? value.substr(start, 3) : value.substr(0, 3 + start))
            + separators[idx] + result;
        idx = (++idx) % 2;
        start -= 3;
    }
    return '$' + result;
}

   

   

    render() {
       const { data, pages, loading,ticket } = this.state;
       console.log('recargar---->',this.state.recargar)
       let recargar = this.state.recargar;
  
           if(recargar==false)
          setTimeout(this.recargar2()
           , 3);
     

        return(
            <div className="view">
            
            
                <div className="view-header">
                    <header className="title text-white">
                        <h1 className="h4 text-uppercase"> Listado de Tickets</h1>
                    </header>
                </div>

                <div className="view-content view-components">
                    <Card>
                        <CardBlock> 
                        <div className="row justify-content-end">
                       <div className="col-sm-2">
                  <div className="form-group">
                    <label className>Estado del Ticket</label>
                    <Select
                      type="text"
                      name="departamento_id"
                      options={tipos}
                      value={parseInt(this.state.tipo)}
                      onChange={ (select) => { this.handleSelectChange(select, 'tipo') } }
                      clearable={false}
                    />
                  </div>
                </div>
                          <div className="col-2  text-left" >
                               <label>Imprimir: </label>{' '}
                            <a target="_blank" href={`${API_UR}/api/imprimir/tickets_departamentos_mes/${this.props.departamento}/${this.props.mes}/${this.props.ano}/${this.state.tipo}`} title="Imprimir ">
                              <FAprint size="30"/>
                            </a>
                          </div>
                          
                        </div>  
                        {(recargar==true)&&<ReactTable
                              data      = {this.state.data}
                              className = "-striped -highlight"
                              columns   = {[
                                {Header: 'Fecha', accessor: 'fecha_pago',maxWidth:100, style: { 'textAlign': 'center'}},
                                {Header: 'No.', accessor: 'clave',maxWidth:150, style: { 'textAlign': 'center'}},
                                {Header: 'Factura', accessor: 'factura',maxWidth:150, style: { 'textAlign': 'center'}},
                                {Header: 'Cliente', accessor: 'cliente'}, 
                                {Header: 'Asesor', accessor: 'asesor'},  
                                {Header: 'Subtotal', accessor: 'subtotal',maxWidth:150 , style: { 'textAlign': 'center'}}, 
                                {Header: 'Costo', accessor: 'costo',maxWidth:150 , filterable: false,  sortable: false, style: { 'textAlign': 'center'}}, 
                                {Header: 'Utilidad', accessor: 'produccion',maxWidth:150 ,filterable: false,  sortable: false, style: { 'textAlign': 'center'}}, 
                                {Header: 'Pagado', accessor: 'pagado',maxWidth:150 ,filterable: false,  sortable: false, style: { 'textAlign': 'center'}}, 
                                {
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                    maxWidth:150,
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-right">
                                                {parseInt(row.original.estado)==1&&
                                                  <Button
                                                 color="success" 
                                                 className="btn-sm" 
                                                 onClick={(evt)=>this.toggle(evt, row.original)}>
                                                    <IconEdit />
                                                </Button>
                                                }
                                                {' '}
                                                 
                                            </div>
                                        )
                                    }
                                }
                              ]}
                              manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                              data={data}
                              pages={pages} // Display the total number of pages
                              loading={loading} // Display the loading overlay when we need it
                              onFetchData={_.debounce(this.fetchData, 500)} // Request new data when things change
                              filterable
                              defaultPageSize={10} 
                              SubComponent={ row => {
                                return(
                                    <Card>
                                        <CardBlock>                                           
                                            <table className="table">
                                              <thead>
                                                <tr>
                                                  <th>Producto</th>
                                                  <th>Descripción</th> 
                                                  <th>Subtotal</th>
                                                  <th>Costo</th>  
                                                  <th>Utilidad</th>                                                
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {
                                                  row.original.productos.map((item, i) => 
                                                  <tr key={i}>
                                                   <td>{item.categoria}</td>
                                                   <td>{item.descripcion}</td>  
                                                     <td>{this.formateo(item.subtotal)}</td> 
                                                     <td>{this.formateo(item.costo_total)}</td>
                                                     <td>{this.formateo(item.produccion)}</td>
                                                  </tr>)
                                                }
                                              </tbody>
                                            </table>
                                        </CardBlock>
                                    </Card>
                                )
                              }}
                             
                            />

                        }                        
                            
                        </CardBlock>
                    </Card>
                </div>

                <Modal isOpen={this.state.modal} toggle={this.toggle} className="default modal-sm">
                <form >
                <ModalHeader toggle={this.toggle}>Cambio de Fecha de Pago</ModalHeader>
                <ModalBody>                              
                  <Row>
                  <Col sm="12">
                      <div className="row mt-3 form_cliente">
                        <div className="col-md-12">
                          <FormGroup>
                            <Label>Ticket: {ticket.clave}</Label>
                          </FormGroup>
                        </div>   
                        <div className="col-md-12">
                          <FormGroup>
                            <Label>Fecha Actual: {ticket.fecha_pago}</Label>
                          </FormGroup>
                        </div>                      
                      </div>
                    </Col>
                    <Col sm="12">
                      <div className="row mt-3 form_cliente">
                        <div className="col-md-12">
                          <FormGroup>
                            <Label>Fecha de pago</Label>
                            <Input
                            placeholder=""
                            type="date"
                            name="fecha_pago"
                            value={this.state.fecha_pago} 
                            onChange={ this.handleInputChange}/>
                          </FormGroup>
                        </div>                        
                      </div>
                    </Col>
                  </Row>   
                </ModalBody>
                <ModalFooter>
                    {
                        this.props.ticket.saving ?
                        <SubmitLoad /> : 
                        <div>
                            <Button color="primary" type="submit"  onClick={this.handleSubmit} >
                                <IconSave />&nbsp;Guardar
                            </Button>{' '}
                            <Button color="secondary" onClick={this.toggle}>
                                Cancel
                            </Button>
                        </div>
                    }
                </ModalFooter>
                </form>
            </Modal>

            </div>
        );
    }

};

function mapStateToProps(state, ownProps) {
    return {
        ticket: state.ticket,
        notificciones:state.notificciones
    }
};

export default connect(mapStateToProps, actions)(TicketTable)


// WEBPACK FOOTER //
// ./src/views/reportes/lista_tickets_contpaq.js